import React, {PropsWithChildren, useState} from "react";
import {useAsync} from "react-async-hook";
import {useLocation} from "react-router-dom";
import {loggingApi} from "../../apis/logging/loggingApi";
import {LoadingPage} from "../../pages/LoadingPage";


export const AccessLog: React.FC = (props: PropsWithChildren<any>) => {
  const { children } = props;
  const location = useLocation();
  const [ currentPathname, setCurrentPathname ] = useState<string | null>(null);

  useAsync(async () => {
    setCurrentPathname(location.pathname);
    loggingApi.log({
      path: location.pathname,
      userAgent: window.navigator.userAgent,
      message: null,
    }, {}).catch((e: object) => {
      console.error(e);
    });
  }, [location]);

  return (
    <div>
      {(currentPathname !== location.pathname) &&
        <LoadingPage />
      }
      {(currentPathname === location.pathname) &&
        <div>
        {children}
        </div>
      }
    </div>
  );
};